function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "arrow_back-24px");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("image", {
  id: "arrow_back-24px",
  x: -5,
  y: -5,
  width: 26,
  height: 26,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAmBJREFUSA29lUtuU0EQRR3z/xMSB8JHIBAokdgJO2DACkIihJBgK0xZhbdgeeKBB7ZkWZZHXoFnMfc8v9sUTT/LRIiWrqu6qrpuV3X3806reexkrnyOexVioh7Ma7W0GI/tucwTOHku87iUMDpicvQ4j3ExOXqcx7hKv5xZYlKTtBVj3eFOem5DLbE7h2MqVyRygJOaAGkdHwkMkqBHwt8ICGCQgFEiwXdJYDMJi8Xiw3K5/F778LM2biTmkuvXwOFgFl4Rrgk3hTvCfeGBsDefz09W9RiPx+9kuy0QR/xVgQ2Ro0TcSHJXC3aFjvBwMpmcmWQ2m32UDfJ7gsmuS99IRjVuUayERAfC4Wg0+mQSdGy1z2RUTmUmoyt5ZVWZbhmB7JBKIHk8HA4/m2QwGHyR7bnwTDDZnnTaC9kt4YbAhnOyiojeUja7oh37wmEk6ff7X2V7LbwSXgibyFxZPLOqRF8AdsTuDmK7er3eN9mOhSPhjfBSoLKnwiOBc3QbfWZ5VYkotW06nZ66XReRImXD5Evt4xr+t+GLQKnbtI5zcuueSN+6dVR1kcvA+TTdvOJlgMhVpXOSbdP13kTC9eYGp/ORzlutfiCiqr95sPGmbfVgm75z/gTxpv7ZJ6iJjJ0WP6rdbvetfLyZ+CWID5Scxrp3tUEiOTi3Elr6m3jfbrdXnU7nh2L4HzL4H4rQtJojE1HUvQuIXKl14hhOuBUJC0gUh+cmK0niTVSS9se8fxDhzMlss90JIgk25gzL9az+zRfbGe3WLR2DdNJcxphK5/00jVLiPNYE2KOex7V+Air6NGhpOcLdAAAAAElFTkSuQmCC"
}));

var SvgArrowBack = function SvgArrowBack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowBack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-back.3ded9b24.svg";
export { ForwardRef as ReactComponent };